import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import headerImage from '../../assets/Header_Image.gif'
import { Dropdown } from 'react-materialize';
const {version} = require('../../../package.json');

interface NavbarProps {
    logo: any;
    memberMe: any;
    pcRegion: string;
    className: string;
    caid: string;
    clientOrg: string;
}

const Navbar: React.FC<NavbarProps> = (props) => {

    // Default logo (src\assets\Header_Image.gif), or logo configured in Multitenant
    const [appLogo, setLogo] = useState<string>();

    /**
     * Reloads/refreshes the app entire app.
     */
    const CustomRefreshAction = () => {
        window.location.reload();
    }
    
    /**
     * Set logo
     */
    const initialize = () => {
        setLogo(
            (props.logo && props.logo.logo && props.logo.logoImageType !== ''
                ? `data:${ props.logo.logoImageType };base64,${ props.logo.logo }`
                : headerImage
            )
        );
    }

    /**
     * Runs once when component is loaded.
     */
    useEffect(() => {
        initialize();
    // eslint-disable-next-line
    }, []);

    return (
        <div className="app-navbar">
            <nav style={{ backgroundColor: "#33383d" }}>
                <div className="nav-wrapper">
                    <span className="brand-logo left" style={{ color: "#ff4f1f" }}><img src={ appLogo } style={ {maxHeight: 50, maxWidth: 200, marginBottom: 10, marginRight: 5, verticalAlign: "middle"} } alt="Header" />Queue Tracker</span>
                    <ul className="right">
                        <Dropdown
                            options={{
                                constrainWidth: false,
                                coverTrigger: false
                            }}
                            trigger={
                                <Link id="user-details" to="#!" style={{ maxHeight: 47, marginTop: 5 }}>
                                    <i id="user-details-icon" className="fa fa-user-circle fa-2x" style={{ maxHeight: 47, height: 47 }}/>
                                </Link>
                            }
                        >
                            <ul className="collection" style={{border: 'none', marginBottom: 0}}>
                                <li className="collection-header" style={{paddingLeft: '10px'}}><h4>User Details</h4></li>
                                <li className='collection-item' style={{border: 'none'}}>{ props.memberMe ? props.memberMe.name : '' }</li>
                                <li className='collection-item'>{ props.memberMe ? props.memberMe.username : '' }</li>
                                <li className='collection-item' style={{border: 'none'}}>Division: { props.memberMe && props.memberMe.division? props.memberMe.division.name : '' }</li>
                                <li className='collection-item' style={{border: 'none'}}>Environment: { props.pcRegion }</li>
                                <li className='collection-item'>Organization: { props.clientOrg }</li>
                                <li className='collection-item' style={{border: 'none', fontSize: 13, textAlign: 'center'}} onClick={ e => CustomRefreshAction() } title="Click to reload app">Version: {version}</li>
                            </ul>
                        </Dropdown>
                    </ul>
                </div>
            </nav>
        </div>
    )
}

export default Navbar;